import React, { useMemo } from "react";

import CustomSection from "../custom-general/custom-section";
import Conditional from "../../common/conditional";
import PDFTablePage from "../../themed/pdf/pdfTablePage";

import { SWUTItem } from "../../forms/custom-swut/swutItemForm";
import { Column } from "../../../utils/models";
import { getChunkedData } from "../../../utils/utilities";

interface Props {
    swutItems: SWUTItem[];
}

const SWUTObservationSummary: React.FC<Props> = ({ swutItems }) => {
    const observations = useMemo(() => {
        return swutItems.flatMap((swut) => swut.observations).map((observation, index) => ({ ...observation, id: index + 1 }));
    }, [swutItems]);

    return ( 
       <Conditional isVisible={observations.length > 0}>
        {getChunkedData(observations, 25).map((chunk, index) => (
            <CustomSection key={index} sectionTitle="Shear Wave Observation Summary">
                <div className="p-1">
                    <PDFTablePage
                        data={chunk}
                        columns={SHEARWAVE_OBSERVATION_COLUMNS}
                    />
                </div>
            </CustomSection>
        ))}
       </Conditional>
    );
};

const SHEARWAVE_OBSERVATION_COLUMNS: Column[] = [
    {
        path: 'id',
        label: 'Sr. Number'
    },
    {
        path: 'jointNumber',
        label: 'Joint / Job Number'
    },
    {
        path: 'comment',
        label: 'Observation'
    },
    {
        path: 'result',
        label: 'Result'
    },
    {
        path: 'defectLength',
        label: 'Defect Length (mm)'
    },
    {
        path: 'defectDepth',
        label: 'Defect Depth'
    },
    {
        path: 'defectHeight',
        label: 'Defect Height'
    },
];
 
export { SHEARWAVE_OBSERVATION_COLUMNS };
export default SWUTObservationSummary;